module.exports = __webpack_public_path__ + "img/seven5Blue.339f36ab.jpg";